var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11C19.8244 11 17.6977 11.6451 15.8887 12.8538C14.0798 14.0625 12.6699 15.7805 11.8373 17.7905C11.0048 19.8005 10.7869 22.0122 11.2114 24.146C11.6358 26.2798 12.6835 28.2398 14.2218 29.7782C15.7602 31.3165 17.7202 32.3642 19.854 32.7886C21.9878 33.2131 24.1995 32.9952 26.2095 32.1627C28.2195 31.3301 29.9375 29.9202 31.1462 28.1113C32.3549 26.3023 33 24.1756 33 22C32.9968 19.0836 31.8369 16.2875 29.7747 14.2253C27.7125 12.1631 24.9164 11.0032 22 11ZM22 12.8333C24.1143 12.8316 26.1634 13.5646 27.797 14.9068L14.9068 27.797C13.8074 26.4548 13.1117 24.828 12.9008 23.1059C12.6899 21.3838 12.9725 19.6371 13.7157 18.0694C14.4589 16.5016 15.632 15.1771 17.0987 14.2502C18.5653 13.3232 20.265 12.8319 22 12.8333ZM22 31.1667C19.8857 31.1684 17.8366 30.4354 16.203 29.0932L29.0932 16.203C30.1926 17.5451 30.8883 19.172 31.0992 20.8941C31.3101 22.6162 31.0275 24.3629 30.2843 25.9306C29.5411 27.4984 28.368 28.8229 26.9013 29.7498C25.4347 30.6768 23.735 31.1681 22 31.1667Z",
    fill: "#062F67"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    stroke: "#D7D7D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/blockIcon.1017b8c53dc2ba4a777496ea3c1fe05f.svg";
export { ForwardRef as ReactComponent };